import { render } from "./DocumentFilePreview.vue?vue&type=template&id=210e1ff2&scoped=true"
import script from "./DocumentFilePreview.vue?vue&type=script&lang=js"
export * from "./DocumentFilePreview.vue?vue&type=script&lang=js"

import "./DocumentFilePreview.vue?vue&type=style&index=0&id=210e1ff2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210e1ff2"]])

export default __exports__